import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import KeysIcon from '@/svg-icons/Keys';

function KeysSection({ keys }) {
  if (!keys || Object.keys(keys).length === 0) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <KeysIcon viewBox="0 0 34.016 34.016" className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="keys" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {keys.simple !== undefined && (
          <div className="w-1/2 mb-[1vw]">
            <div className="font-bold">
              <FormattedMessage id="simple" />
            </div>
            <div data-cy="order-details-keys-simple">{keys.simple}</div>
          </div>
        )}
        
        {keys.foursided !== undefined && (
          <div className="w-1/2 mb-[1vw]">
            <div className="font-bold">
              <FormattedMessage id="foursided" />
            </div>
            <div data-cy="order-details-keys-foursided">{keys.foursided}</div>
          </div>
        )}

        {keys.others !== undefined && (
          <div className="w-full mb-[1vw]">
            <div className="font-bold">
              <FormattedMessage id="others" />
            </div>
            <div data-cy="order-details-keys-others">{keys.others}</div>
          </div>
        )}

        {keys.notes !== undefined && (
          <div className="w-full mb-[1vw]">
            <div className="font-bold">
              <FormattedMessage id="notes" />
            </div>
            <div className="whitespace-pre-wrap" data-cy="order-details-keys-notes">
              {keys.notes}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

KeysSection.propTypes = {
  keys: PropTypes.object.isRequired,
};

export default KeysSection;
